import React, { useContext } from 'react';
import { EditProductContext } from '../EditProductView';
import { Col, Container, Row } from 'react-bootstrap';
import Loader from '../../../../components/Loader/Loader';
import SelectItem from '../../../../components/ThemeSelectOption/SelectOption';
import ProductImageUpload from '../../common/ProductImageUpload';
import ContentData from '../../../../constants/contentFile.json';
import RadioButton from '../../../../components/RadioButtonComponent/RadioButton';
import InputComponent from '../../../../components/InputComponent/InputComponent';
import NextIcon from '../../../../assets/images/next-icon.svg';
import './editProduct.css';
import BorderButton from '../../../../components/BorderButton/BorderButton';
import ThemeButton from '../../../../components/ThemeButton/ThemeButton';
import SuccessPopupAlert from '../../../../components/PopupAlertSuccess/PopupAlert';
import ErrorPopup from '../../../../components/PopupAlertError/PopupAlertError';
import ToggleArrow from '../../../../assets/images/Toggle-arrow.svg';

const EditProduct = () => {
  const {
    spinnerStatus,
    goToProductList,
    formData,
    handleChange,
    fileUrl,
    onImageChange,
    clearImage,
    imgError,
    selectedFile,
    goToProductDetails,
    currentTabValue,
    successAlertMessage,
    successAlertShow,
    editProduct,
    errors,
    errorPopup,
    errorPopupMessage,
    setErrorPopup,
    goToLogin,
    buttonText,
    statusValue,
  } = useContext(EditProductContext);
  const productType =
    currentTabValue == '1'
      ? 'inverter'
      : currentTabValue == '2'
      ? 'battery'
      : 'comboProduct';

  return (
    <div className="pageBg edit-product">
      <div className="breadCrums">
        <span className="breadCrumsPointing" onClick={goToProductList}>
          {ContentData.productPage.pageTitle}
        </span>
        <img className="nextIcon " src={NextIcon} alt="next icon" />
        <span className="breadCrumsPointing" onClick={goToProductDetails}>
          {ContentData.productPage.productDetail}
        </span>
        <img className="nextIcon " src={NextIcon} alt="next icon" />
        <span className="boldBreadCrums">
          {ContentData.productPage.editProduct}
        </span>
      </div>
      <Container>
        {spinnerStatus && <Loader />}
        <div className="flexPage">
          <div className="headFlexing">
            <button
              type="button"
              onClick={goToProductDetails}
              class="navbar-btn"
            >
              <img src={ToggleArrow} alt="toggle-arrow" />
            </button>
            <div className="pageTittles">
              {ContentData.productPage.editProduct}
            </div>
          </div>
        </div>
        <form onSubmit={editProduct}>
          <div className="basicContainer">
            <Row>
              <Col xl="12" lg="12" sm="12">
                <div className="product-type">
                  <div className="adminDetailSectionTop roleSubPage">
                    <div className="product-type-name">{productType}</div>
                  </div>
                </div>
              </Col>
            </Row>
            <div className="viewAdminSection addAdminSection">
              <Row>
                {/* model */}
                <Col xl="4" lg="4" sm="12">
                  <div className="adminDetailSection">
                    <div className="adminDetailSectionTop roleSubPage">
                      <h4>{ContentData.productPage.Model}</h4>
                      <InputComponent
                        placeholder={ContentData.productPage.enterName}
                        name="model"
                        value={formData.model}
                        type="text"
                        onChange={handleChange}
                      />
                      <p className="mb-0 error-msg">{errors.model}</p>
                    </div>
                  </div>
                </Col>
                {productType === 'inverter' && (
                  <>
                    {/* power */}
                    <Col xl="4" lg="4" sm="12">
                      <div className="adminDetailSection">
                        <div className="adminDetailSectionTop roleSubPage">
                          <h4>{ContentData.productPage.Power}</h4>
                          <InputComponent
                            placeholder={ContentData.productPage.enterPower}
                            name="power"
                            value={formData.power}
                            type="text"
                            onChange={handleChange}
                          />
                          <p className="mb-0 error-msg">{errors.power}</p>
                        </div>
                      </div>
                    </Col>
                    <Col xl="4" lg="4" sm="12">
                      <div className="adminDetailSection">
                        <div className="adminDetailSectionTop roleSubPage">
                          <h4>{ContentData.productPage.PowerVA}</h4>
                          <InputComponent
                            placeholder={ContentData.productPage.enterPower}
                            name="powerInVoltAmperes"
                            value={formData.powerInVoltAmperes}
                            type="text"
                            onChange={handleChange}
                          />
                          <p className="mb-0 error-msg">
                            {errors.powerInVoltAmperes}
                          </p>
                        </div>
                      </div>
                    </Col>
                    {/* battery volt */}
                    <Col xl="4" lg="4" sm="12">
                      <div className="adminDetailSection">
                        <div className="adminDetailSectionTop roleSubPage">
                          <h4>{ContentData.productPage.BattVolt}</h4>
                          <InputComponent
                            placeholder={ContentData.productPage.enterVolt}
                            name="volt"
                            value={formData.volt}
                            type="text"
                            onChange={handleChange}
                          />
                          <p className="mb-0 error-msg">{errors.volt}</p>
                        </div>
                      </div>
                    </Col>
                    {/*type */}
                    <Col xl="4" lg="4" sm="12">
                      <div className="adminDetailSection">
                        <div className="adminDetailSectionTop roleSubPage">
                          <h4>{ContentData.productPage.Type}</h4>
                          <InputComponent
                            placeholder={ContentData.productPage.enterType}
                            name="type"
                            value={formData.type}
                            type="text"
                            onChange={handleChange}
                          />
                          <p className="mb-0 error-msg">{errors.type}</p>
                        </div>
                      </div>
                    </Col>

                    {/* product Link */}
                    <Col xl="4" lg="4" sm="12">
                      <div className="adminDetailSection">
                        <div className="adminDetailSectionTop roleSubPage">
                          <h4>{ContentData.productPage.ProductLink}</h4>
                          <InputComponent
                            placeholder={
                              ContentData.productPage.enterProductLink
                            }
                            name="productLink"
                            value={formData.productLink}
                            type="text"
                            onChange={handleChange}
                          />
                          <p className="mb-0 error-msg">{errors.productLink}</p>
                        </div>
                      </div>
                    </Col>

                    {/* connectivity */}
                    <Col xl="4" lg="4" sm="12">
                      <div className="adminDetailSection">
                        <div className="adminDetailSectionTop roleSubPage">
                          <h4>{ContentData.productPage.Connectivity}</h4>
                          <div className="option-selection">
                            <RadioButton
                              label="Yes"
                              name="connectivity"
                              id="connectivity-yes"
                              checked={formData.connectivity === 'Yes'}
                              handleCheck={handleChange}
                            />
                            <RadioButton
                              label="No"
                              name="connectivity"
                              id="connectivity-no"
                              checked={formData.connectivity === 'No'}
                              handleCheck={handleChange}
                            />
                          </div>
                          <p className="mb-0 error-msg">
                            {errors.connectivity}
                          </p>
                        </div>
                      </div>
                    </Col>
                    {/* solar model */}
                    <Col xl="4" lg="4" sm="12">
                      <div className="adminDetailSection">
                        <div className="adminDetailSectionTop roleSubPage">
                          <h4>{ContentData.productPage.SolarModel}</h4>
                          <div className="option-selection">
                            <RadioButton
                              label="Yes"
                              name="solarModal"
                              id="solarModal-yes"
                              checked={formData.solarModal === 'Yes'}
                              handleCheck={handleChange}
                            />
                            <RadioButton
                              label="No"
                              name="solarModal"
                              id="solarModal-no"
                              checked={formData.solarModal === 'No'}
                              handleCheck={handleChange}
                            />
                          </div>
                          <p className="mb-0 error-msg">{errors.solarModal}</p>
                        </div>
                      </div>
                    </Col>
                  </>
                )}
                {productType === 'battery' && (
                  <>
                    {/* capcity */}
                    <Col xl="4" lg="4" sm="12">
                      <div className="adminDetailSection">
                        <div className="adminDetailSectionTop roleSubPage">
                          <h4>{ContentData.productPage.Capacity}</h4>
                          <InputComponent
                            placeholder={ContentData.productPage.enterCapacity}
                            name="capacity"
                            value={formData.capacity}
                            type="text"
                            onChange={handleChange}
                          />
                          <p className="mb-0 error-msg">{errors.capacity}</p>
                        </div>
                      </div>
                    </Col>
                  </>
                )}
                {productType === 'comboProduct' && (
                  <>
                    {/* power */}
                    <Col xl="4" lg="4" sm="12">
                      <div className="adminDetailSection">
                        <div className="adminDetailSectionTop roleSubPage">
                          <h4>{ContentData.productPage.Power}</h4>
                          <InputComponent
                            placeholder={ContentData.productPage.enterPower}
                            name="power"
                            value={formData.power}
                            type="text"
                            onChange={handleChange}
                          />
                          <p className="mb-0 error-msg">{errors.power}</p>
                        </div>
                      </div>
                    </Col>
                    <Col xl="4" lg="4" sm="12">
                      <div className="adminDetailSection">
                        <div className="adminDetailSectionTop roleSubPage">
                          <h4>{ContentData.productPage.PowerVA}</h4>
                          <InputComponent
                            placeholder={ContentData.productPage.enterPower}
                            name="powerInVoltAmperes"
                            value={formData.powerInVoltAmperes}
                            type="text"
                            onChange={handleChange}
                          />
                          <p className="mb-0 error-msg">
                            {errors.powerInVoltAmperes}
                          </p>
                        </div>
                      </div>
                    </Col>
                    {/* battery volt */}
                    <Col xl="4" lg="4" sm="12">
                      <div className="adminDetailSection">
                        <div className="adminDetailSectionTop roleSubPage">
                          <h4>{ContentData.productPage.BattVolt}</h4>
                          <InputComponent
                            placeholder={ContentData.productPage.enterVolt}
                            name="volt"
                            value={formData.volt}
                            type="text"
                            onChange={handleChange}
                          />
                          <p className="mb-0 error-msg">{errors.volt}</p>
                        </div>
                      </div>
                    </Col>
                    {/*type */}
                    <Col xl="4" lg="4" sm="12">
                      <div className="adminDetailSection">
                        <div className="adminDetailSectionTop roleSubPage">
                          <h4>{ContentData.productPage.Type}</h4>
                          <InputComponent
                            placeholder={ContentData.productPage.enterType}
                            name="type"
                            value={formData.type}
                            type="text"
                            onChange={handleChange}
                          />
                          <p className="mb-0 error-msg">{errors.type}</p>
                        </div>
                      </div>
                    </Col>

                    {/* product Link */}
                    <Col xl="4" lg="4" sm="12">
                      <div className="adminDetailSection">
                        <div className="adminDetailSectionTop roleSubPage">
                          <h4>{ContentData.productPage.ProductLink}</h4>
                          <InputComponent
                            placeholder={
                              ContentData.productPage.enterProductLink
                            }
                            name="productLink"
                            value={formData.productLink}
                            type="text"
                            onChange={handleChange}
                          />
                          <p className="mb-0 error-msg">{errors.productLink}</p>
                        </div>
                      </div>
                    </Col>

                    {/* connectivity */}
                    <Col xl="4" lg="4" sm="12">
                      <div className="adminDetailSection">
                        <div className="adminDetailSectionTop roleSubPage">
                          <h4>{ContentData.productPage.Connectivity}</h4>
                          <div className="option-selection">
                            <RadioButton
                              label="Yes"
                              name="connectivity"
                              id="connectivity-yes"
                              checked={formData.connectivity === 'Yes'}
                              handleCheck={handleChange}
                            />
                            <RadioButton
                              label="No"
                              name="connectivity"
                              id="connectivity-no"
                              checked={formData.connectivity === 'No'}
                              handleCheck={handleChange}
                            />
                          </div>
                          <p className="mb-0 error-msg">
                            {errors.connectivity}
                          </p>
                        </div>
                      </div>
                    </Col>
                    {/* solar model */}
                    <Col xl="4" lg="4" sm="12">
                      <div className="adminDetailSection">
                        <div className="adminDetailSectionTop roleSubPage">
                          <h4>{ContentData.productPage.SolarModel}</h4>
                          <div className="option-selection">
                            <RadioButton
                              label="Yes"
                              name="solarModal"
                              id="solarModal-yes"
                              checked={formData.solarModal === 'Yes'}
                              handleCheck={handleChange}
                            />
                            <RadioButton
                              label="No"
                              name="solarModal"
                              id="solarModal-no"
                              checked={formData.solarModal === 'No'}
                              handleCheck={handleChange}
                            />
                          </div>
                          <p className="mb-0 error-msg">{errors.solarModal}</p>
                        </div>
                      </div>
                    </Col>
                  </>
                )}

                {/* site origin */}
                <Col xl="4" lg="4" sm="12">
                  <div className="adminDetailSection">
                    <div className="adminDetailSectionTop roleSubPage">
                      <h4>{ContentData.productPage.SiteOrigin}</h4>
                      <div className="option-selection">
                        <RadioButton
                          label="vguard.com"
                          name="siteOrgin"
                          id="siteOrgin-yes"
                          checked={formData.siteOrgin === 'vguard.com'}
                          handleCheck={handleChange}
                        />
                        <RadioButton
                          label="vguard.in"
                          name="siteOrgin"
                          id="siteOrgin-no"
                          checked={formData.siteOrgin === 'vguard.in'}
                          handleCheck={handleChange}
                        />
                      </div>
                      <p className="mb-0 error-msg">{errors.siteOrgin}</p>
                    </div>
                  </div>
                </Col>
              </Row>
              <ProductImageUpload
                fileUrl={fileUrl}
                onImageChange={onImageChange}
                clearImage={clearImage}
                imgError={imgError}
                selectedFile={selectedFile}
              />
            </div>
          </div>

          <div className="bottomButtons">
            <BorderButton
              value={ContentData.authPage.cancelText}
              onClick={goToProductDetails}
            />
            <ThemeButton
              value={ContentData.authPage.submitText}
              id="submitAddEditBtn"
              type="submit"
            />
          </div>
        </form>
      </Container>
      <SuccessPopupAlert
        show={successAlertShow}
        alertMessage={successAlertMessage}
        handleSubmit={goToProductDetails}
      />
      <ErrorPopup
        show={errorPopup}
        alertMessage={errorPopupMessage}
        buttonText={buttonText}
        status={statusValue}
        handleCancel={() => setErrorPopup(false)}
        handleSubmit={() => {
          if (statusValue === 401 || statusValue === 403) {
            goToLogin();
            setErrorPopup(false);
          } else {
            setErrorPopup(false);
          }
        }}
        errorAlertOnly={statusValue === 400 ? true : false}
      />
    </div>
  );
};

export default EditProduct;
